<template>
  <div class="header-container">
    <!-- <h1>{{config.title}}</h1> -->
    <img src="@/assets/banner.png" style="" />

    <div v-resize="onResize" class="clock">

      <el-dropdown v-resize="onResize" class="login-user">
      <span> <img src="@/assets/user.png" class="user-avatar" style="width: .2344rem;position: absolute;left: -0.2344rem;top: .0469rem;" /><span>{{loginUser}}</span></span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <span @click="about">关于</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>


      <span class="clock-date">{{clock.date}}</span>
      <br>
      <!-- <span class="clock-time">{{clock.time}}</span> -->




     
    
    </div>

   
   



  </div>
</template>
<script>
/* global $config */
import { getNickName, removeToken } from '../../utils/auth'
import { logout } from '../../api/logout.js'
export default {
  data () {
    return {
      clock: {
        date: '',
        time: ''
      },
      config: $config
    }
  },
  computed: {
    loginUser () {
      return getNickName()
    }
  },
  mounted () {
    this.startClock()
  },
  methods: {
    loadClock () {
      var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      var cd = new Date()
      this.clock.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2)
      this.clock.date = zeroPadding(cd.getFullYear(), 4) + '/' + zeroPadding(cd.getMonth() + 1, 2) + '/' + zeroPadding(cd.getDate(), 2) + ' ' + week[cd.getDay()]
    },
    startClock () {
      this.loadClock()
      setInterval(this.loadClock, 1000)
    },
    logout () {
      logout()
        .then(resp => {
          if (resp.errmsg === 'ok') {
            removeToken()
            this.$commons.toLogin()
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    about () {
      var version = '1.0'
      this.$alert(`版本 ${version}`, `关于${this.config.title}`, {
        confirmButtonText: '确定'
      })
    }
  }
}
function zeroPadding (num, digit) {
  var zero = ''
  for (var i = 0; i < digit; i++) {
    zero += '0'
  }
  return (zero + num).slice(-digit)
}
</script>

<style scoped>
.header-container {
  width: 100%;
  height:.3385rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.clock {
  position: absolute;
  right: .1042rem;
  top: .0521rem;
  min-width: .5208rem;
  line-height: .1354rem;
  padding-left: .0521rem;
}
.clock-date {
  font-size: .0625rem;
}
.clock-time {
  font-size: .1302rem;
  font-weight: 700;
}
.login-user{
  
  line-height: .3125rem;
  color:#fff;
  font-size: .0938rem;
  padding-left: .0521rem;
  cursor: pointer;
}



</style>


// WEBPACK FOOTER //
// src/components/index/Header.vue